import React, { useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { SafeHtmlParser } from "./SafeHtmlParser";
import gsap from "gsap";
import useOnScreen from "./use-on-screen";

const IconsLayout2 = ({ heading, items }) => {
	// Ref for the outer section
	const containerRef = useRef(null);
	// Determine if the section is visible (using a 10px offset)
	const isVisible = useOnScreen(containerRef, "10px");

	useEffect(() => {
		if (isVisible) {
			// Animate the left column (heading) with a rotation effect
			const leftItems = gsap.utils.toArray(".left-item");
			gsap.from(leftItems, {
				duration: 1,
				rotation: 5, // Slight rotation to give a "coming up" feel
				transformOrigin: "-40px 100%", // All left items pivot around the same invisible point
				opacity: 0,
				ease: "power2.out",
				stagger: 0.3,
				delay: 1,
			});

			// Animate the right column's items (icon list)
			const rightAnimateEls = gsap.utils.toArray(".right-animate");
			rightAnimateEls.forEach((el) => {
				gsap.from(el.children, {
					opacity: 0,
					duration: 1,
					stagger: 0.2,
					ease: "power2.out",
					delay: 0.4,
				});
			});
		}
	}, [isVisible]);

	return (
		<section className="py-5 py-lg-7" ref={containerRef}>
			<Container>
				<Row className="g-5 g-lg-7">
					{/* Left Column: Heading */}
					<Col lg={6}>
						<div className="text-primary left-item">
							<SafeHtmlParser htmlContent={heading} />
						</div>
					</Col>

					{/* Right Column: Icon List */}
					<Col lg={6}>
						<div className="right-animate" style={iconListWrapperStyles}>
							{items.map((item, index) => (
								<div key={index} style={iconItemStyles}>
									<div className="me-5">
										<img
											src={item.icon.sourceUrl}
											alt={item.heading}
											style={iconStyles}
										/>
										{index !== 3 && (
											<div
												className="mx-auto tall-line mt-3"
												style={{
													width: "2px",
													background: "#CEE4FF",
												}}
											></div>
										)}
									</div>
									<div style={textWrapperStyles}>
										<h3 style={{ color: item.colour }}>{item.heading}</h3>
										<p>{item.body}</p>
									</div>
								</div>
							))}
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

// Inline styles
const iconListWrapperStyles = {
	position: "relative",
};

const iconItemStyles = {
	display: "flex",
	alignItems: "flex-start",
	marginBottom: "2rem",
	position: "relative",
};

const iconStyles = {
	width: "45px",
};

const textWrapperStyles = {
	flex: 1,
};

export default IconsLayout2;
